import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Card, field, btn, fmtTs } from "./ui";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TEMPLATES = [
  ["thanks", "Thanks for reaching out"],
  ["followup", "Checking in / follow-up"],
  ["quote", "Next steps / quote ready"],
];

export const EmailsTab = ({ auth }) => {
  const [leads, setLeads] = useState([]);
  const [sent, setSent] = useState([]);
  const [leadId, setLeadId] = useState("");
  const [tpl, setTpl] = useState("thanks");
  const [note, setNote] = useState("");
  const [sending, setSending] = useState(false);

  const load = () => {
    axios.get(`${API}/leads`, auth).then((r) => setLeads(r.data.filter((l) => l.email))).catch(() => {});
    axios.get(`${API}/admin/sent-emails`, auth).then((r) => setSent(r.data)).catch(() => {});
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const send = async () => {
    if (!leadId) { toast.error("Pick a lead first."); return; }
    setSending(true);
    try {
      await axios.post(`${API}/admin/leads/${leadId}/email`, { template: tpl, note }, auth);
      toast.success("Email sent.");
      setNote("");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Send failed.");
    } finally { setSending(false); }
  };

  return (
    <div className="space-y-8" data-testid="emails-tab">
      <Card title="Send a Follow-Up" color="bg-staxmagenta" testid="email-compose-card">
        <p className="mb-4 font-mono2 text-[10px] uppercase tracking-widest text-ink/45 leading-relaxed">
          One-to-one emails to people who contacted you. For bulk newsletters, use a dedicated tool like Mailchimp — this inbox stays personal.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <select data-testid="email-lead-select" value={leadId} onChange={(e) => setLeadId(e.target.value)} className={field}>
            <option value="">Choose a lead...</option>
            {leads.map((l) => (
              <option key={l.id} value={l.id}>{l.name || "Unnamed"} — {l.email}</option>
            ))}
          </select>
          <select data-testid="email-template-select" value={tpl} onChange={(e) => setTpl(e.target.value)} className={field}>
            {TEMPLATES.map(([v, label]) => <option key={v} value={v}>{label}</option>)}
          </select>
        </div>
        <textarea
          data-testid="email-note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Optional personal note, added to the template..."
          className={`${field} mt-3 min-h-[90px] resize-none`}
        />
        <button data-testid="email-send-button" onClick={send} disabled={sending} className={`${btn} mt-3 bg-staxmagenta text-white`}>
          <Send size={15} /> {sending ? "Sending..." : "Send Email"}
        </button>
      </Card>

      <Card title="Sent History" color="bg-staxcyan" testid="sent-emails-list">
        {sent.length === 0 && <p className="font-mono2 text-xs uppercase tracking-widest text-ink/40">No emails sent yet.</p>}
        <ul className="space-y-2">
          {sent.map((s) => (
            <li key={s.id} className="flex flex-wrap items-center justify-between gap-2 border-2 border-ink/15 bg-white px-4 py-2.5">
              <span className="text-sm font-semibold">{s.lead_name || s.to}</span>
              <span className="font-mono2 text-[10px] uppercase tracking-widest text-ink/50">
                {s.template} · {fmtTs(s.ts)}
              </span>
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
};
